export const DEFAULT_FILTER = {
  category: {
    name: '',
    id: ''
  },
  options: []
}

export const DEFAULT_EMAIL_PREFERENCE = {
  name: '',
  editing: true,
  isDirty: false,
  active: true,
  filters: [DEFAULT_FILTER]
}
